var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import makeStyles from '@mui/styles/makeStyles';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Button } from '../';
import { CircularProgress } from '@mui/material';

var useStyles = makeStyles(function (theme) {
  return {
    container: {
      boxShadow: 'none',
      width: '100%',
      padding: 20
    },
    textarea: {
      width: '100%',
      margin: theme.spacing(0.5, 0, 0, 0)
    },
    title: _extends({
      paddingBottom: 30
    }, R.pathOr({}, ['mixins', 'share', 'title'], theme)),
    textAreaWrapper: {
      display: 'flex',
      flexGrow: 1
    }
  };
});

var ShortUrls = function ShortUrls(_ref) {
  var labels = _ref.labels,
      onClick = _ref.onClick,
      isLoading = _ref.isLoading,
      contentValue = _ref.contentValue,
      _ref$isNotifOpen = _ref.isNotifOpen,
      isNotifOpen = _ref$isNotifOpen === undefined ? false : _ref$isNotifOpen,
      setIsNotifOpen = _ref.setIsNotifOpen;

  var isNarrow = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });
  var classes = useStyles();

  return React.createElement(
    Grid,
    { className: classes.container },
    React.createElement(
      Typography,
      { variant: 'h6', className: classes.title },
      R.prop('title')(labels)
    ),
    React.createElement(
      Grid,
      {
        container: true,
        justifyContent: isNarrow ? 'center' : 'flex-start',
        alignItems: isNarrow ? 'left' : 'center',
        direction: isNarrow ? 'column-reverse' : 'row'
      },
      React.createElement(
        Grid,
        { item: true, style: { padding: isNarrow ? '20px 0 0 0' : '0 20px 0 0' } },
        React.createElement(
          Button,
          {
            'aria-label': R.propOr('', 'generateUrl')(labels),
            type: 'submit',
            variant: 'contained',
            color: 'primary',
            disabled: isLoading || R.isNil(onClick),
            alternative: 'siscc',
            onClick: onClick,
            className: classes.submitButton
          },
          isLoading ? React.createElement(CircularProgress, { size: 24 }) : R.propOr('', 'generateUrl')(labels)
        )
      ),
      React.createElement(
        Grid,
        { item: true, className: classes.textAreaWrapper },
        React.createElement(TextareaAutosize, {
          'aria-label': contentValue,
          className: classes.textarea,
          minRows: 2,
          maxRows: 2,
          readOnly: true,
          value: contentValue
        })
      )
    ),
    React.createElement(
      Collapse,
      { 'in': isNotifOpen },
      React.createElement(
        Alert,
        {
          severity: 'error',
          action: React.createElement(
            IconButton,
            {
              'aria-label': 'close',
              color: 'inherit',
              size: 'small',
              onClick: function onClick() {
                setIsNotifOpen(false);
              }
            },
            React.createElement(CloseIcon, { fontSize: 'inherit' })
          )
        },
        R.prop('errorMessage', labels)
      )
    )
  );
};
ShortUrls.propTypes = process.env.NODE_ENV !== "production" ? {
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  contentValue: PropTypes.string,
  isNotifOpen: PropTypes.bool,
  setIsNotifOpen: PropTypes.func,
  labels: PropTypes.shape({
    generateUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  })
} : {};
export default ShortUrls;